import { combineReducers } from 'redux';
import { purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './auth.reducer';

import { AUTH_LOGOUT, AUTH_REQUEST } from '../actions/constants/auth.constants';
import { persistConfig } from '../../index';

import loadingReducer from './sagasstatus.reducer';
import encargosWorkspace from './encargos.reducer';
import grideable from './grideable.reducer';
import driveReducer from './drive.reducer';
import mensajesSistema from './mensajesSistema.reducer';
import giotalkReducer from './giotalk.reducer';
import pelReducer from './pel.reducer';
import appReducer from './app.reducer';
import coreReducer from './core.reducer';
import articulosReducer from './articulos.reducer';
import creadorEncargosReducer from './encargos.creador.reducer';
import trazadora from './trazadora.reducer';
import informesReducer from './informes.reducer';
import handleCajaModal from './caja.reducer';
import newCoReposicionesReducer from './newCo.reposiciones.reducer';
import pacientesWorkspace from './pacientes.reducer';
import fichaOptometricaWorkspace from './fichaOptometrica.reducer';
import fichaContactologicaWorkspace from './fichaContactologica.reducer';
import proveedoresWorkspace from './proveedors.reducer';
import pedidoslcWorkspace from './pedidoslc.reducer';
import comerciaDatafonoWorkspace from './comercia.datafono.reducer';
import comerciaDatafonoWifiWorkspace from './comercia.datafono.wifi.reducer';
import { sendMessageGW1 } from '../../helpers/GW1sendMessage.helper';


const reducer = combineReducers({
  auth: authReducer,
  sagas: loadingReducer,
  encargosWorkspace,
  handleCajaModal,
  grideable,
  drive: driveReducer,
  mensajesSistema,
  giotalk: giotalkReducer,
  pel: pelReducer,
  app: appReducer,
  core: coreReducer,
  articulos: articulosReducer,
  encargosCreador: creadorEncargosReducer,
  trazadora,
  informes: informesReducer,
  newCoReposiciones: newCoReposicionesReducer,
  pacientesWorkspace,
  fichaOptometricaWorkspace,
  fichaContactologicaWorkspace,
  proveedoresWorkspace,
  pedidoslcWorkspace,
  comerciaDatafonoWorkspace,
  comerciaDatafonoWifiWorkspace,
});
const rootReducer = (state, action) => {
  if (action.type === AUTH_REQUEST) { // check for action type
    purgeStoredState(persistConfig);
    storage.removeItem('persist:root');
    localStorage.removeItem('token');
    return reducer(state, action);
  }
  if (action.type === AUTH_LOGOUT) { // check for action type
    purgeStoredState(persistConfig);
    storage.removeItem('persist:root');
    localStorage.removeItem('token');
    return reducer(undefined, action);
  }
  const inIframe = window.top != window.self;
  if (inIframe) {
    sendMessageGW1({ action: action.type, payload: action.payload });
  }
  return reducer(state, action);
};
export default rootReducer;
